import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import "./ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";

export default function ApproveAwards() {
  const [applications, setApplications] = useState([]);
  const [currentAppID, setCurrentAppID] = useState(null);
  const [selectedYear, setSelectedYear] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || 'http://localhost:5000/uploads';

  // Fetch applications from the backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/getShortlistedApplications`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Applications:", data);
        if (Array.isArray(data)) {
          setApplications(data);
        } else {
          console.error("API did not return an array for applications:", data);
        }
      })
      .catch((error) => console.error("Error fetching applications:", error));
  }, [API_BASE_URL]);

  // Generate years from 2000 to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => 2024 + i
  );

  // Filter applications based on selected year
  const filteredApplications = applications.filter((app) => {
    const matchesYear = selectedYear
      ? new Date(app.SubmittedDate).getFullYear().toString() === selectedYear
      : true;
    return matchesYear;
  });

  // Handle approve/reject action
  const handleClick = (app_ID, status) => {
    fetch(`${API_BASE_URL}/updateApplicationStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ applicationId: app_ID, status }),
    })
      .then((response) => response.json())
      .then((data) => {
        alert(`Application ID: ${app_ID} has been ${status}`);
        setApplications((prevApplications) =>
          prevApplications.map((app) =>
            app.Application_Id === app_ID ? { ...app, Status: status } : app
          )
        );
      })
      .catch((error) => {
        console.error("Error updating application status:", error);
        alert("Error updating application status.");
      });
  };

  // Open modal
  const handleOpenModal = (app_ID) => {
    setCurrentAppID(app_ID);
    setShowModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentAppID(null);
  };

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">
        Submit for Review - Dean Approve / Reject (Shortlisted Applications)
      </h1>
      <div style={{ margin: "20px 0", display: "flex", gap: "20px",fontWeight: "bold",}}>
        <div>
          <label htmlFor="yearFilter">Filter by Year: </label>
          <select
            id="yearFilter"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "100px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">All Years</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Applicant Name</th>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Action</th>
            <th>Application</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) &&
            filteredApplications.map((app) => (
              <tr key={app.Application_Id}>
                <td>{app.Applicant_Name || app.Name}</td>
                <td>{app.Application_Id}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>{app.Status}</td>
                <td>
                  {app.Status === "Approved" ? (
                    <Button variant="success">Approved</Button>
                  ) : app.Status === "Rejected" ? (
                    <Button variant="danger">Rejected</Button>
                  ) : (
                    <Button
                      className={(app.Sent ?? 0) === 1 ? "btn-purple" : "View_Button"}
                      variant={(app.Sent ?? 0) === 1 ? "secondary" : "primary"}
                      onClick={() => {
                        navigate("/sendemaildean", {
                          state: {
                            applicationId: app.Application_Id,
                            awardType: app.Award_Type,
                          },
                        });
                      }}
                    >
                      {(app.Sent ?? 0) === 1 ? "Sent" : "Send Email"}
                    </Button>
                  )}
                </td>
                <td>
                  <button
                    className="View_Button"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title className="modaltitle">
            Select Application Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            variant="success"
            className="granted_deny"
            onClick={() => {
              handleClick(currentAppID, "Approved");
              handleCloseModal();
            }}
          >
            Approve
          </Button>
          <Button
            variant="danger"
            className="granted_deny"
            onClick={() => {
              handleClick(currentAppID, "Rejected");
              handleCloseModal();
            }}
          >
            Reject
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}